export function formatPrice(value: number, language: 'ar' | 'he' = 'ar') {
  if (Number(value) <= 0) return language === 'he' ? 'מחיר לפי בקשה' : 'السعر عند الطلب';
  const formatted = new Intl.NumberFormat(language === 'he' ? 'he-IL' : 'ar-IL', { maximumFractionDigits: 0 }).format(Number(value));
  return `${formatted} ₪`;
}

export const CURRENCY = 'ILS';
